import React from "react";
import Title from "components/Title";
import AddColor from "./AddColor";
const TableHeader = () => {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-between gx-mb-3"
      style={{ flexWrap: "wrap" }}
    >
      <Title title="color.title" />
      <AddColor />
    </div>
  );
};

export default TableHeader;
